import { APP_ID, signal } from '@angular/core';
import { parseAgrEnvironment } from '@next/core-lib/environment';
import { ENVIRONMENT_MAPPER } from '@next/core-lib/environment-browser';
import { environment } from 'src/environments/environment';

const loadedConfig = signal({ ...environment });
export const setupRuntimeConfig = (async () => {
  try {
    const response = await globalThis.fetch('/assets/config.json');
    if (response.ok) {
      const config = await response.json();
      loadedConfig.set({ ...environment, ...parseAgrEnvironment(config) });
    } else {
      console.warn('No runtime configuration found, using default environment settings.');
    }
  } catch (e) {
    console.warn('Failed to load runtime environment variables', e);
  }
})();
export const APP_BROWSER_RUNTIME_PROVIDERS = [
  {
    provide: ENVIRONMENT_MAPPER,
    useFactory: () => {
      return { ...loadedConfig() };
    },
  },
  {
    provide: APP_ID,
    useFactory: () => loadedConfig().APPLICATION_NAME,
  },
];
